import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQueryWithAuth } from "../methods/baseQueryWithAuth";
import { reducerPaths } from "../../app/reducerPaths";

export const authApi = createApi({
	reducerPath: reducerPaths.authApi,
	baseQuery: baseQueryWithAuth,
	endpoints: (builder) => ({
		getProfileDetails: builder.query({
			query: () => {
				return {
					url: `/dealer/profile`,
					method: "GET"
				}
			}
		}),
		updateProfile: builder.mutation({
			query: ({ formData }) => {
				return {
					method: "POST",
					url: `/dealer/profile/update`,
					body: formData
				}
			}
		}),
	}),
});

export const {
  useUpdateProfileMutation,
	useLazyGetProfileDetailsQuery
} = authApi;
